<template>
  <div>
    <p v-if="educationNameText" class="text-grey-body">{{ educationNameText }}</p>
    <p v-if="educationSubText" class="text-grey-body flex text-small items-center mt-8">{{ educationSubText }}</p>
  </div>
</template>

<script lang="ts">
interface Education {
  schoolName?: string;
  yearGraduated?: string | null;
  levelOfEducation?: string | null;
  major?: string;
  currentlyAttending?: boolean;
}

export default {
  name: 'ProfileEducation',
  props: {
    education: {
      type: Object as () => Education,
      default: () => ({}),
    },
    careType: {
      type: String,
      required: true,
    },
  },
  computed: {
    educationNameText(): string {
      const { schoolName } = this.education as Education;
      return schoolName || '';
    },
    educationSubText(): string {
      const { levelOfEducation, currentlyAttending, major, yearGraduated } = this.education as Education;

      const hasYearGraduated = yearGraduated && yearGraduated !== 'Select';
      const graduationText = hasYearGraduated ? `, ${yearGraduated}` : '';

      const getAttendedText = (defaultText: string) => (currentlyAttending ? 'Currently attending' : defaultText);

      switch (levelOfEducation) {
        case 'some_high_school':
          return getAttendedText('Attended');

        case 'high_school_degree':
          return getAttendedText('Graduated') + graduationText;

        case 'some_college':
        case 'some_graduate_school':
          return major ? `${currentlyAttending ? 'Majoring' : 'Attended, Majored'} in ${major}` : getAttendedText('Attended');

        case 'college_degree':
          return major
            ? `${currentlyAttending ? 'Majoring' : 'Degree'} in ${major}${graduationText}`
            : getAttendedText('Graduated') + graduationText;

        case 'graduate_degree':
          return major
            ? `${currentlyAttending ? 'Majoring' : 'Graduate degree'} in ${major}${graduationText}`
            : getAttendedText('Graduate program') + graduationText;
        default:
          return '';
      }
    },
  },
};
</script>
